import { render, staticRenderFns } from "./ed-designer-image.component.vue?vue&type=template&id=3fb7ca36&scoped=true&"
import script from "./ed-designer-image.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-image.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-image.component.scss?vue&type=style&index=0&id=3fb7ca36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7ca36",
  null
  
)

export default component.exports